import type { FC } from "react";
import type { PartnerLifecycleStatus } from "../../api/partners";
import { StatusChip, type Colors } from "../../shared/StatusChip";

const partnerLifecycleStatusColors: Record<PartnerLifecycleStatus, Omit<Colors, "dot">> = {
  inactive: {
    background: theme => theme.palette.brandBlue["50"],
    border: theme => theme.palette.brandBlue["400"],
    text: theme => theme.palette.brandBlue["900"],
  },
  active: {
    background: theme => theme.palette.teal["100"],
    border: theme => theme.palette.teal["400"],
    text: theme => theme.palette.teal["900"],
  },
  archived: {
    background: theme => theme.palette.grey["200"],
    border: theme => theme.palette.grey["400"],
    text: theme => theme.palette.text.primary,
  },
};

export const PartnerLifecycleStatusChip: FC<{ status: PartnerLifecycleStatus }> = ({ status }) => {
  const colors = partnerLifecycleStatusColors[status];
  if (!colors) return null;
  return <StatusChip colors={colors} labelKey={`PartnerLifecycleStatus.${status}`} />;
};
